import styled from 'styled-components'

export const Wrapper = styled.div``
export const List = styled.ul`
  list-style: disc;
  padding-left: 20px;
  margin-bottom: 40px;

  & > li:not(:first-child) {
    margin-top: 20px;
  }

  & a {
    color: var(--brand-secondary);
  }
`
export const Buttons = styled.div`
  display: flex;

  & > button:first-child {
    margin-right: 16px;
  }
`
